<template>
  <div id="app">
    <head-bar ref="headerbar"></head-bar>
    <!-- <img src="./assets/logo.png"> -->
    <div id="download-dialog" ref="downloadDialog">
      <div class="download-dialog-wrap">
        <div class="download-dialog-header">
          <p id="download-dialog-md-title">
            <span class="icon iconfont viewAddtodownload-copy"></span>
            {{$t('downloadDialog.title')}}
          </p>
          <!-- <p id="download-dialog-xs-title">3D FastView</p> -->
          <span class="icon iconfont viewziyuanldpi" @click="closeDialog"></span>
        </div>
        <div class="download-dialog-body">
          <p class="download-dialog-label">{{$t('downloadDialog.version')}}</p>
          <div class="download-dialog-list">
            <div class="download-dialog-list-item">
              <p @click="selectHandle('standard,32',$event)">
                {{$t('downloadDialog.standard')}} 32bit
                <img
                  src="../static/images/download-select@2x.png"
                  alt
                />
              </p>
              <p @click="selectHandle('standard,64',$event)">
                {{$t('downloadDialog.standard')}} 64bit
                <img
                  src="../static/images/download-unselect@2x.png"
                  alt
                />
              </p>
            </div>
            <div class="download-dialog-list-item">
              <p @click="selectHandle('professional,32',$event)">
                {{$t('downloadDialog.professional')}} 32bit
                <img
                  src="../static/images/download-unselect@2x.png"
                  alt
                />
              </p>
              <p @click="selectHandle('professional,64',$event)">
                {{$t('downloadDialog.professional')}} 64bit
                <img
                  src="../static/images/download-unselect@2x.png"
                  alt
                />
              </p>
            </div>
          </div>
          <p class="download-dialog-label">{{$t('footer.lang')}}</p>
          <el-select
            class="download-language"
            v-model="lang"
            :placeholder="$t('footer.langSelect')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <button @click="onSubmit">{{$t('downloadDialog.confirm')}}</button>
      </div>
    </div>
    <div id="download-email-dialog" ref="downloadEmailDialog">
      <div class="download-dialog-wrap">
        <div class="download-dialog-header">
          <p id="download-dialog-xs-title">{{$t('footer.title')}}</p>
          <span class="icon iconfont viewziyuanldpi" @click="closeEmailDialog"></span>
        </div>
        <div id="download-dialog-body-xs">
          <div>
            <p>{{$t('downloadDialog.linkName')}}</p>
            <p>{{$t('downloadDialog.link')}}</p>
            <p>{{$t('downloadDialog.inputName')}}</p>
            <input type="text" v-model="email" :placeholder="$t('downloadDialog.inputHolder')" />
          </div>
          <button @click="onSubmitXs">{{$t('downloadDialog.confirm')}}</button>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('buy.dialog.title')"
      custom-class="buy-dialog"
      :visible.sync="dialogVisible"
      :modal="true"
      status-icon="true"
      width="40%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <div class="buy-dialog-first-div">
          <el-form-item
            class="buy-dialog-formitem"
            :label="$t('buy.dialog.name.label')"
            prop="name"
          >
            <el-input v-model="ruleForm.name" :placeholder="$t('buy.dialog.name.placeHolder')"></el-input>
          </el-form-item>
          <el-form-item
            class="buy-dialog-formitem"
            :label="$t('buy.dialog.email.label')"
            prop="email"
          >
            <el-input v-model="ruleForm.email" :placeholder="$t('buy.dialog.email.placeHolder')"></el-input>
          </el-form-item>
          <el-form-item
            class="buy-dialog-formitem"
            :label="$t('buy.dialog.numberLi.label')"
            prop="numberLi"
          >
            <el-input
              v-model="ruleForm.numberLi"
              :placeholder="$t('buy.dialog.numberLi.placeHolder')"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="buy-dialog-formitem nostar"
            :label="$t('buy.dialog.phoneNumber.label')"
            prop="phoneNumer"
          >
            <el-input
              v-model="ruleForm.phoneNumber"
              :placeholder="$t('buy.dialog.phoneNumber.placeHolder')"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item class="buy-dialog-formitem out-box" label="Company Name" prop="company">
          <el-input v-model="ruleForm.company" placeholder="Please enter your company name"></el-input>
        </el-form-item>
        <el-form-item
          class="buy-dialog-formitem nostar out-box"
          :label="$t('buy.dialog.region.label')"
          prop="region"
        >
          <el-select v-model="ruleForm.industry" :placeholder="$t('buy.dialog.region.placeHolder')">
            <el-option v-for="item in industry" :key="item.value" :label="item.label" :value="item.value"></el-option>
            <!-- <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
        </el-form-item>

        <el-form-item
          class="buy-dialog-formitem nostar out-box"
          id="area"
          :label="$t('buy.dialog.desc.label')"
          prop="desc"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.desc"
            :placeholder="$t('buy.dialog.desc.placeHolder')"
          ></el-input>
        </el-form-item>
        <p id="error" v-if="error">
          <span class="icon iconfont viewerror"></span>
          {{error}}
        </p>
        <p id="info">{{$t('buy.dialog.info')}}</p>
        <el-form-item>
          <el-button
            id="submit"
            type="primary"
            :disabled="isSubmit"
            @click="submitForm(ruleForm)"
          >{{$t('buy.dialog.submit')}}</el-button>
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>-->
    </el-dialog>

    <el-dialog
      custom-class="buy-finish-dialog"
      :visible.sync="dialogEmailFinishVisible"
      :modal="true"
      width="40%"
    >
      <div class="buy-finish-box">
        <span class="icon iconfont viewxiaolian"></span>
        <p>{{$t('downloadDialog.finish.name')}}</p>
        <p>{{$t('downloadDialog.finish.subName')}}</p>
      </div>
    </el-dialog>

    <el-dialog
      ref="video"
      custom-class="video-dialog"
      :visible.sync="videoVisible"
      :modal="true"
      width="80%"
    >
      <video id="dialog-video" controls :src="videoUrl" autoplay></video>
    </el-dialog>
    <router-view />
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import headBar from "../src/components/HeadBar";
import footerBar from "../src/components/FooterBar";
import animate from "animate.css";
import { addTrial, downInstallPackage,addMessage } from "../src/utils/http/loadData";
export default {
  name: "App",
  data() {
    return {
      dialogEmailFinishVisible: false,
      lang: "en",
      selectProduct: 1,
      versionId: 2,
      softbit: "32",
      email: "",
      videoUrl: "",
      videoVisible: false,
      options: [
        {
          value: "en",
          label: "English"
        },
        {
          value: "kr",
          label: "한국어"
        }
      ],
      dialogVisible: false,
      dialogFinishVisible: true,
      isSubmit: true,
      error:'',
      productList: {
        standard: {},
        professional: {},
        enterprise: {}
      },
      industry:[
        {label:'Aerospace',value:'Aerospace'},
        {label:'Agriculture Forestry',value:'Agriculture Forestry'},
        {label:'Automobile / Motorcycle',value:'Automobile / Motorcycle'},
        {label:'Energy/Utilities',value:'Energy/Utilities'},
        {label:'Federal',value:'Federal'},
        {label:'Higher Education',value:'Higher Education'},
        {label:'Heavy Machinery',value:'Heavy Machinery'},
        {label:'Hospitals/Health Care',value:'Hospitals/Health Care'},
        {label:'Insurance',value:'Insurance'},
        {label:'IT Services',value:'IT Services'},
        {label:'Logistics/Transportation/Manufacturing',value:'Logistics/Transportation/Manufacturing'},
        {label:'Medical Devices',value:'Medical Devices'},
        {label:'Minerals & Mining',value:'Minerals & Mining'},
        {label:'Non-Profit',value:'Non-Profit'},
        {label:'Oil& Gas',value:'Oil& Gas'},
        {label:'Personal User',value:'Personal User'},
        {label:'Pharmaceuticals',value:'Pharmaceuticals'},
        {label:'Precision Instrument',value:'Precision Instrument'},
        {label:'Professional Services',value:'Professional Services'},
        {label:'Real Estate/Property Management/Restaurants',value:'Real Estate/Property Management/Restaurants'},
        {label:'Retail',value:'Retail'},
        {label:'Services',value:'Services'},
        {label:'Shipbuilding',value:'Shipbuilding'},
        {label:'States',value:'States'},
        {label:'Telecom/Communication Services',value:'Telecom/Communication Services'},
        {label:'Wholesale',value:'Wholesale'},
        {label:'Other',value:'Other'},
      ],
      ruleForm: {
        name: "",
        email: "",
        numberLi: "",
        phoneNumber: "",
        company: "",
        industry: "",
        desc: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please enter your name",
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: "2 to 20 characters in length",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "Please enter the email number",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (value === "") {
                callback(new Error("Please fill in the mailbox correctly"));
              } else {
                if (value !== "") {
                  var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                  if (!reg.test(value)) {
                    callback(new Error("Please enter a valid email address"));
                  }
                } else {
                  callback();
                }
              }
            },
            trigger: "blur"
          }
        ],
        numberLi: [
          { required: true, message: "Number of users", trigger: "blur" },
          {
            min: 0,
            max: 10,
            message: "0 to 10 characters in length",
            trigger: "blur"
          },
          {
            validator:function(rule,value,callback){
              if(/^\+?[1-9][0-9]*$/.test(value)==false){
                callback(new Error('please enter a valid number'))
              }else{
                callback()
              }
            }
          }
        ],
        phoneNumber: [
          {
            required: true,
            message: "Please enter the phone number",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (/^1[34578]\d{9}$/.test(value) == false) {
                callback(new Error("please enter a valid phone number"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        company: [
          {
            required: true,
            message: "Please enter your company name",
            trigger: "blur"
          },
          {
            min: 3,
            max: 100,
            message: "3 to 100 characters in length",
            trigger: "blur"
          }
        ],
        region: [
          {
            required: false,
            message: "Please select industry",
            trigger: "change"
          }
        ],
        desc: [{ required: false, message: "Your thoughts", trigger: "blur" }]
      }
    };
  },
  watch: {
    videoVisible(val) {
      if (!val) {
        this.videoUrl = "";
      }
    },
    ruleForm: {
      handler() {
        // console.log("form");
        var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (
          this.ruleForm.name &&
          this.ruleForm.email &&
          this.ruleForm.numberLi &&
          this.ruleForm.company  &&
          reg.test(this.ruleForm.email)
        ) {
          this.isSubmit = false;
        } else {
          this.isSubmit = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    selectHandle(type, event) {
      // console.log(event.target.tagName)
      var li = type.split(",");
      this.softbit = li[1];
      switch (li[0]) {
        case "standard":
          this.versionId = "2";
          break;
        case "professional":
          this.versionId = "3";
          break;
        default:
          this.versionId = "2";
          break;
      }
      var domList = document.querySelectorAll(".download-dialog-list-item");
      for (var i = 0; i < domList.length; i++) {
        // console.log(domList[i].children[0])
        for (var j = 0; j < domList[i].children.length; j++) {
          // console.log(domList[i].children[j])
          domList[i].children[j].children[0].src =
            "../static/images/download-unselect@2x.png";
        }
      }
      if (event.target.tagName === "P") {
        event.target.children[0].src =
          "../static/images/download-select@2x.png";
        // if(event.target.children[0].src==='../static/images/download-unselect@2x.png'){
        //   event.target.children[0].src='../static/images/download-select@2x.png'
        // }else{
        //   event.target.children[0].src='../static/images/download-unselect@2x.png'
        // }
        // console.log(event.target.children[0].src='../static/images/download-select@2x.png')
      } else if (event.target.tagName === "IMG") {
        // console.log('img')
        event.target.src = "../static/images/download-select@2x.png";
      } else {
        return;
      }
    },
    initGtag(){
      window.dataLayer = window.dataLayer || [];
    },
    gtag() {
      console.log(window.dataLayer)
      window.dataLayer.push(arguments);
    },
    gtag_report_conversion(url) {
      this.gtag("js", new Date());

      this.gtag("config", "AW-831366347");
      var callback = function() {
        if (typeof url === "undefined") {
          window.location = url;
        }
      };
      //download  AW-831366347/l8x_CJeft5oBEMvJtowD
      this.gtag("event", "conversion", {
        send_to: "AW-831366347/l8x_CJeft5oBEMvJtowD",
        event_callback: callback
      });
      return false;
    },
    openDia() {
      this.dialogVisible = true;
      this.ruleForm.name = "";
      this.ruleForm.email = "";
      this.ruleForm.numberLi = "";
      this.ruleForm.phoneNumber = "";
      this.ruleForm.company = "";
      this.ruleForm.industry = "";
      this.ruleForm.desc = "";
    },
    submitForm(ruleForm) {
      addMessage(
        'Request for quotation',
        "en",
        ruleForm.name,
        ruleForm.company,
        ruleForm.phoneNumber,
        ruleForm.email,
        ruleForm.industry,
        ruleForm.desc,
        ruleForm.numberLi
      ).then(res => {
        let response = res.data;
        console.log(response);
        if (response.rtnCode === "0000000") {
          this.dialogVisible = false;
          this.dialogFinishVisible = true;
        }else{
          this.error = response.msg
        }
      });
      console.log(ruleForm);
    },
    changeForm() {
      console.log("form");
      if (
        this.ruleForm.name &&
        this.ruleForm.email &&
        this.ruleForm.numberLi &&
        this.ruleForm.company
      ) {
        this.isSubmit = false;
      }
    },
    onSubmit() {
      // standard:2;professional:3;enterprise:4
      this.gtag_report_conversion(window.location.href);
      downInstallPackage(this.versionId, this.lang, this.softbit).then(res => {
        if (res.data.rtnCode === "0000000") {
          console.log(res);
          this.closeDialog();
          this.closeEmailDialog();
          // this.dialogEmailFinishVisible = true
          // window.location.href=res.data.bizData.downloadLink
          if (res.data.bizData.downloadLink) {
            window.location.href=res.data.bizData.downloadLink
          } else {
            alert("Not Found Software Package！");
          }
        } else {
          alert(res.data.msg);
        }
      });
    },
    onSubmitXs() {
      addTrial(this.email).then(res => {
        console.log(res);
        if (res.data.rtnCode === "0000000") {
          this.dialogEmailFinishVisible = true;
        } else {
          alert(res.data.msg);
        }
      });
      this.closeEmailDialog();
    },
    closeDialog() {
      this.$refs.downloadDialog.style.visibility = "hidden";
    },
    closeEmailDialog() {
      this.$refs.downloadEmailDialog.style.visibility = "hidden";
    },
    showDialog() {
      if (document.body.clientWidth <= 768) {
        this.$refs.downloadEmailDialog.style.visibility = "visible";
      } else {
        this.$refs.downloadDialog.style.visibility = "visible";
      }
    },
    showVideo(path) {
      this.videoUrl = path;
      this.videoVisible = true;
    }
  },
  mounted() {
    this.$i18n.locale = "en";
     this.$jsonp("https://www.googletagmanager.com/gtag/js?id=AW-831366347").then(
        this.gtag
      )
    this.initGtag()
  },
  components: {
    headBar,
    footerBar
  }
};
</script>

<style lang="scss">
@import "../static/css/app.scss";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue